import { TFunction } from 'react-i18next';
import { api } from 'common';
import { Notifications } from '../../scenes/Notifications';
import * as store from '../../reducers/store';

///////////////////////////////////////////////////
////// TYPES and CONST

export interface SchedulingStateProps {
  coordinates?: store.Coordinates;
}

export interface SchedulingDispatchProps {
  setCoordinates: (coordinates: api.Places.Geometry) => void;
}

///////////////////////////////////////////////////
////// HELPER FUNCTIONS

const defaultSort = (
  displayByFieldConfig: api.PrevisitFormTemplateFieldConfig.ScheduleAppointmentDisplayBy | null,
) => {
  return {
    sort:
      displayByFieldConfig ===
      api.PrevisitFormTemplateFieldConfig.ScheduleAppointmentDisplayBy.Practice
        ? api.EhrTimeSlot.Sorting.AvailabilityPractice
        : api.EhrTimeSlot.Sorting.AvailabilityProvider,
  };
};

export const getSortBy = async (
  sortByFieldConfig: api.PrevisitFormTemplateFieldConfig.ScheduleAppointmentSortBy | null,
  displayByFieldConfig: api.PrevisitFormTemplateFieldConfig.ScheduleAppointmentDisplayBy | null,
) => {
  switch (sortByFieldConfig) {
    case api.PrevisitFormTemplateFieldConfig.ScheduleAppointmentSortBy
      .Alphabetically:
      return {
        sort:
          displayByFieldConfig ===
          api.PrevisitFormTemplateFieldConfig.ScheduleAppointmentDisplayBy
            .Practice
            ? api.EhrTimeSlot.Sorting.AlphabeticallyPractice
            : api.EhrTimeSlot.Sorting.AlphabeticallyProvider,
      };
    case api.PrevisitFormTemplateFieldConfig.ScheduleAppointmentSortBy.Distance:
      return { sort: api.EhrTimeSlot.Sorting.Distance };
    default:
      return defaultSort(displayByFieldConfig);
  }
};

export const errorHandleGeoLocation = (
  displayBy:
    | api.PrevisitFormTemplateFieldConfig.ScheduleAppointmentDisplayBy
    | null
    | undefined,
  t: TFunction,
) => {
  const errorText = t(
    'Unable to use distance for sorting appointments. Using Availability.',
  );
  Notifications.notify({
    body: errorText,
    vertical: 'top',
  });
  return {
    sort:
      displayBy ===
      api.PrevisitFormTemplateFieldConfig.ScheduleAppointmentDisplayBy.Practice
        ? api.EhrTimeSlot.Sorting.AvailabilityPractice
        : api.EhrTimeSlot.Sorting.AvailabilityProvider,
  };
};
